import React from "react";
import { Box, Tooltip, Typography } from "@mui/material";
import {
  MedicationOutlined,
  Check,
  Close,
  WarningAmber,
  HelpOutline,
} from "@mui/icons-material";
import { formatTimeToAmPm } from "../../../../../base/FormatTime";

const STATUS_CONFIG = {
  Given: { color: "#4caf50", icon: Check },
  "Not Given": { color: "#f44336", icon: Close },
  Missed: { color: "#f44336", icon: Close },
  "Low Stock": { color: "#ff9800", icon: WarningAmber },
  Default: { color: "#9e9e9e", icon: MedicationOutlined },
};

const getStatusColor = (status) => {
  if (!status) return STATUS_CONFIG.Default.color;
  return (STATUS_CONFIG[status] || STATUS_CONFIG.Default).color;
};

const getStatusIcon = (status, reason) => {
  if (reason && reason.trim() !== "" && status !== "Given") {
    return (
      <Typography sx={{ color: "white", fontWeight: "bold", fontSize: 16 }}>
        {reason.trim().charAt(0).toUpperCase()}
      </Typography>
    );
  }

  const IconComponent = (STATUS_CONFIG[status] || STATUS_CONFIG.Default).icon;
  return <IconComponent sx={{ color: "white", fontSize: 22 }} />;
};

const formatTooltipContent = ({ status, reason, time, stock_status, notes }) => {
  const lines = [];

  if (status === "Given") {
    lines.push("Status: Administered");
  } else if (status === "Not Given" || status === "Missed") {
    lines.push("Status: Not Administered / Missed");
  }

  if (reason) {
    lines.push(`Reason: ${reason}`);
  }

  if (time) {
    const formattedTime = formatTimeToAmPm(time);
    if (formattedTime && formattedTime !== "--") {
      lines.push(`Time: ${formattedTime}`);
    }
  }

  if (stock_status) {
    lines.push(`Stock: ${stock_status}`);
  }

  if (notes) {
    lines.push(`Notes: ${notes}`);
  }

  return lines.join("\n").trim() || "No Data";
};

const EventStatusIcon = ({ status, reason, time, stock_status, notes }) => {
  const tooltipText = formatTooltipContent({
    status,
    reason,
    time,
    stock_status,
    notes,
  });

  const finalStatus = stock_status === "Low Stock" ? "Low Stock" : status;

  return (
    <Tooltip
      title={<pre style={{ margin: 0, fontFamily: "inherit" }}>{tooltipText}</pre>}
      arrow
      componentsProps={{
        tooltip: {
          sx: {
            bgcolor: "#FEF3C7",
            color: "#1A1A2E",
            boxShadow: 2,
            fontSize: 13,
            borderRadius: 1,
            whiteSpace: "pre-wrap",
            border: "1px solid #FDE68A",
          },
        },
      }}
    >
      <Box
        sx={{
          width: "30px",
          height: "30px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: getStatusColor(finalStatus),
          borderRadius: "50%",
          ml: 1,
          cursor: "pointer",
        }}
      >
        {getStatusIcon(finalStatus, reason)}
      </Box>
    </Tooltip>
  );
};

export default EventStatusIcon;